import { RefObject, useEffect, useState } from "react";

// 드롭다운 이벤트 커스텀 훅
const useDropdown = (ref: RefObject<HTMLElement>) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handleClose = (e: Event) => {
      if (ref.current?.contains(e.target as HTMLElement)) return;
      setShow(false);
    };

    if (show) {
      document.body.addEventListener("click", handleClose);
    }

    return () => {
      document.body.removeEventListener("click", handleClose);
    };
  }, [show]);

  return [show, setShow] as const;
};

export default useDropdown;
